import { render, staticRenderFns } from "./SubCategoriesList.vue?vue&type=template&id=0d06c428&scoped=true"
import script from "./SubCategoriesList.vue?vue&type=script&lang=js"
export * from "./SubCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d06c428",
  null
  
)

export default component.exports